/* Mind Glow Glass — HOME redesign behaviour: reveal on scroll, hero light-up, swipe progress bars.
   Loaded by every mgg-home-* section; guarded so it initialises once. */
(function () {
  if (window.__mghInit) return;
  window.__mghInit = true;
  document.documentElement.classList.add('mh-js');

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mh-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' })
    : null;

  function bar(track) {
    var ind = track.parentElement.querySelector('[data-mh-bar] i');
    if (!ind) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var vis = track.clientWidth / Math.max(track.scrollWidth, 1);
      ind.style.width = (vis * 100) + '%';
      ind.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * ((1 / vis) - 1) * 100 : 0) + '%)';
    }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init(root) {
    root.querySelectorAll('.mh-rv,.mh-beam,.mh-story').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('mh-in');
    });
    root.querySelectorAll('.mh-hero').forEach(function (h) {
      requestAnimationFrame(function () { setTimeout(function () { h.classList.add('mh-lit'); }, 80); });
    });
    root.querySelectorAll('[data-mh-track]').forEach(bar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  /* Theme editor: re-run on section reload */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
